module.exports = __webpack_public_path__ + "img/img_cmag6.f57423fc.png";